import { FC, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import EmailInput from '../common/elements/EmailInput';
import {
  Container,
  ContentBox,
  ErrorText
} from '../../styles/chime-react/CommonStyles';
import Heading from '../chat/Heading';
import { BottomButtonWrap } from '../../pages/login';
import PrimaryButton from '../chat/Button/PrimaryButton';
import { useRouter } from 'next/router';
import { getUrl } from '../../utils/url';
import { ErrorMessageConstant, Errors } from '../../constants';
import { useLoading } from '../../providers/LoadingProvider';
import { useDebouncedCallback } from 'use-debounce';
import { PasswordResetParams } from '../../api/backend/PasswordResetApi';

type PasswordResetForm = { email: string };
const PasswordReset = () => {
  const router = useRouter();
  const { setLoading } = useLoading();
  const form = useForm<PasswordResetForm>({ defaultValues: { email: '' } });
  const { handleSubmit } = form;
  const resetPassword = (form: PasswordResetForm) => {
    setConfirmError('');
    setLoading(true);

    const body: PasswordResetParams = {
      email: form.email
    };
    fetch(getUrl('/api/issuer/passwordReset'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then((response) => {
        if (response.ok) {
          setConfirmError('');
          router.push({
            pathname: '/login/password_reset/',
            query: { email: form.email }
          });
        } else {
          response
            .json()
            .then(
              ({
                errorCode
              }: {
                errorCode: keyof typeof ErrorMessageConstant;
              }) => {
                setConfirmError(
                  ErrorMessageConstant[errorCode] ||
                    'パスワードの再設定に失敗しました'
                );
              }
            );
        }
      })
      .finally(() => setLoading(false));
  };
  const resetPasswordDebounced = useDebouncedCallback(resetPassword, 3_000, {
    leading: true,
    trailing: false
  });

  const [confirmError, setConfirmError] = useState('');

  return (
    <Container maxWidth="fit-content">
      <Heading level={4} tag="h1" alignCenter={true} mb="2.5rem">
        パスワードの再設定
      </Heading>
      <form onSubmit={handleSubmit(resetPasswordDebounced)}>
        <ContentBox>
          <div style={{ marginBottom: '2.25rem' }}>
            メールアドレスを入力して、[パスワードを再発行する]を押してください。​
            <br />
            パスワード再設定のメールを送信します。​
            <br />
            ※ドメイン指定受信をされている方は、connect-athome.jpを許可してください
          </div>
          <EmailInput required={true} form={form} />
        </ContentBox>

        <BottomButtonWrap>
          {confirmError && (
            <ErrorText className="error-text">{confirmError}</ErrorText>
          )}
          <PrimaryButton label="パスワードを再発行する" />
        </BottomButtonWrap>
      </form>
    </Container>
  );
};

export default PasswordReset;
